import React from "react";
import cn from "classnames";
import styles from "./styles.css";

const Link = (props) => {
  const { children, className, ...rest } = props;

  return (
    <a {...rest} className={cn(styles.link, className)}>
      {children}
    </a>
  );
};

export default Link;
